import { render, staticRenderFns } from "./SnapshotSaveImportModel.vue?vue&type=template&id=54ed0c67&scoped=true&"
import script from "./SnapshotSaveImportModel.vue?vue&type=script&lang=ts&"
export * from "./SnapshotSaveImportModel.vue?vue&type=script&lang=ts&"
import style0 from "./SnapshotSaveImportModel.vue?vue&type=style&index=0&id=54ed0c67&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ed0c67",
  null
  
)

export default component.exports